import * as Three from 'three';
import { parseObject } from './object';

export const parseTile = (branch, context, options) => {
  const { _selfKey, parent } = options;
  const {
    positionX,
    positionY = 0,
    positionZ,
    color = 0x3399ff,
    previewOnly = false,
    material = 'industrial-concrete'
  } = branch;

  if (!parent) {
    return;
  }

  let instance = parent.getObjectByName(_selfKey);

  if (!instance) {
    const isWaterTile = material === 'water';
    instance = new Three.Group();

    const tile = parseObject({
      ...branch,
      sizeX: 10,
      sizeY: 2,
      sizeZ: 10,
      positionX: 0,
      positionY: 1.5,
      positionZ: 0,
      color,
      primitive: 'cube',
      opacity: previewOnly ? 0.5 : (isWaterTile ? 0.0 : 1.0),
      materialId: material,
    }, context, {
      ...options,
      parent: instance,
      selectable: true,
      selectionTarget: false
    });
    tile.castShadow = false;
    tile.name = 'sideA';

    if (!isWaterTile) {
      const shadowMesh = new Three.Mesh(
        new Three.PlaneBufferGeometry(10, 10, 1, 1),
        new Three.MeshBasicMaterial({ color: 0x000000, side: Three.DoubleSide, opacity: 0, transparent: true })
      );
      shadowMesh.rotation.x = -Math.PI / 2;
      shadowMesh.castShadow = true;
      shadowMesh.receiveShadow = false;
      instance.add(shadowMesh);
    }

    instance.position.x = positionX;
    instance.position.y = positionY;
    instance.position.z = positionZ;

    instance.selectable = true;
    instance.selectionTarget = true;
    parent.add(instance);
  }

  return instance;
};
